<template>
  <div class="result-list-container cs-scroll-style" v-visible-track="'Iframe.ancientDnaNotableConnectionsPageView'">
    <SpinnerContainer v-if="!uiResults && this.$store.state.appConfig.isLoading"/>
    <template v-else>
      <div class="fit-container-genetic-similarity">
        <span class="cursor-pointer" @click="geneticFitInfoModal.showModal = true" 
          v-click-track="'Iframe.ancientDnaNotableConnectionsTabWhatIsGeneticFitClicked'">
          {{$tI('Genetic Fit')}} 
          <span class="open-info-modal-btn">
            <InfoIcon />
          </span>
        </span>
      </div>
      <div class="pop-view">
        <div v-for="itemAncestry in uiResults"
            :key="itemAncestry.title"
            @click="onOpenDetailPage(itemAncestry)"
            :class="['pop-view-item', { 'selected': isSelected(itemAncestry) }]"
            v-click-track="'Iframe.ancientDnaNotableConnectionsTabPopulationClickFromLeftPanel'">
          <div class="d-flex">
            <b-media-aside class="mr-75">
              <b-avatar
                rounded
                size="55"
                :src="itemAncestry.logoUrl"
              />
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0">
                {{ itemAncestry.tTitle }}
              </h6>
            </b-media-body>
          </div>
          <div class="d-flex align-items-center lab-p-8">
            <span class="mr-75 percent-txt" :style="{ color: itemAncestry.gradHSL }"><b>{{ Number(itemAncestry.distance).toFixed(3) }}</b></span>
          </div>
        </div>
      </div>

      <GeneticFitInfoModal v-if="geneticFitInfoModal.showModal" :modalObject="geneticFitInfoModal"/>
    </template>
  </div>
</template>

<script>
import InfoIcon from '@/components/icons/InfoIcon.vue';
import GeneticFitInfoModal from '../../genetic-similarities/Modals/GeneticFitInfoModal.vue'

export default {
  components: {
    InfoIcon,
    GeneticFitInfoModal,
  },
  directives: {
  },
  data() {
    return {
      geneticFitInfoModal: {
        showModal: false,
      },
      selectedItemId: null,
    }
  },
  methods: {
    onOpenDetailPage(item) {
      if (!item.id) {
        return;
      }
      this.selectedItemId = item.id;
      this.$store.dispatch('ancientNotableIndividualResult/fetchDetail', { report: 'SingleOrigin,' + item.title, id: item.id });
      this.$store.state.ancientNotableIndividualResult.isOpenedDetail = true;
    },
    isSelected(item) {
      return item.id && item.id === this.selectedItemId;
    },
  },
  watch: {
    uiResults(results) {
      if (results && results.length && !this.selectedItemId && !this.isMobile) {
        this.onOpenDetailPage(results[0]);
      }
    },
  },
  computed: {
    uiResults() {
      return this.$store.getters['ancientNotableIndividualResult/getUiResults'];
    },
    isMobile() {
      return this.$store.state.appConfig.windowWidth < 769;
    },
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.result-list-container {
  padding: 28px;
  flex: 1;
  overflow-y: auto;

  .fit-container-genetic-similarity {
    color: var(--black-40);
    text-align: end;
    font-size: 0.9rem;
    .open-info-modal-btn {
      margin-left: 5px;
    }
  }

  .pop-view-item {
    outline: none;
    border: 1px solid transparent !important;
    box-shadow: none !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.25s linear !important;

    &.selected {
      border-color: #D988ED !important;
      box-shadow: 0px 0px 10px 0px #A73CBD33 !important;
    }
  }
}

</style>
